import styled from 'styled-components';

export const StyledIconHeader = styled.div(
  ({ theme: { space } }) => `
  display: flex;
  width: 100%;
  gap: ${space[2]}
`,
);

export const StyledIconHeaderText = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;

  > * {
    margin: 0;
  }
`;

export const StyledIconHeaderIcon = styled.div(
  ({ theme: { mediaQueries, space, colors } }) => `
    color: ${colors.primary};
    font-size: 4rem;
    line-height: 1;
    margin-top: ${space[1]};
    svg[data-icon="gas"] {
      color: ${colors.fuelGas};
    }    
    svg[data-icon="electricity"] {
      color: ${colors.fuelElec};
    }
    ${mediaQueries.smallAndUp} {
      font-size: 4.8rem;
      margin-right: ${space[3]};
    }
  `,
);
